import BankLink from './BankLink'

export default BankLink
